var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoommatePreference(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.667 20.7805V6.16853M6.667 20.7805H4M6.667 20.7805H7.5M18.333 20.7805V6.16553C18.333 5.08953 17.438 4.22053 16.333 4.22053H14.5M18.333 20.7805H14.5M18.333 20.7805H21M11.5 13.4745V11.5265M6.67 4.46353L13.282 3.02353C13.907 2.88853 14.5 3.35153 14.5 3.97553V21.0255C14.5 21.6495 13.907 22.1125 13.282 21.9765L6.67 20.5365V4.46353Z",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoommatePreference);
export default __webpack_public_path__ + "static/media/Roommate_Preference.be3255684c3afa6ead974ee92a0bee77.svg";
export { ForwardRef as ReactComponent };